import React from 'react';

// Single lazy import shared by the mobile Slider and the desktop carousel, so
// both resolve the same chunk and the path only changes in one place.
export default React.lazy(() => import('../../node_modules/nuka-carousel'));
